import { DuctedFuelToken } from './kept-system-type-annotation';
import { FurnaceFuel } from './system-composition-types';

const FURNACE_FUEL_TO_DUCTED: Record<FurnaceFuel, DuctedFuelToken> = {
  ng: 'ng',
  lp: 'lp',
  oil: 'o',
  electric: 'e'
};

const DUCTED_TO_FURNACE_FUEL: Record<DuctedFuelToken, FurnaceFuel> = {
  ng: 'ng',
  lp: 'lp',
  o: 'oil',
  e: 'electric'
};

export const furnaceFuelToDucted = (fuel: FurnaceFuel): DuctedFuelToken =>
  FURNACE_FUEL_TO_DUCTED[fuel];

export const ductedToFurnaceFuel = (token: DuctedFuelToken): FurnaceFuel =>
  DUCTED_TO_FURNACE_FUEL[token];

export const furnaceFuelFromDuctedSelections = (
  selections: DuctedFuelToken[]
): FurnaceFuel | null =>
  selections.length === 1 ? ductedToFurnaceFuel(selections[0]) : null;

export const sameDuctedFuelSelections = (
  left: DuctedFuelToken[],
  right: DuctedFuelToken[]
): boolean =>
  left.length === right.length &&
  left.every((token, index) => token === right[index]);
